import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'

function UsersTable ({ rows, setLoading }) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableWrap}>
        <table className={classes.table}>
          <TableHeader />
          <tbody className={classes.tableBody}>
            {rows &&
              rows.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={item.userId}
                  item={item}
                  setLoading={setLoading}
                />
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
export default UsersTable
